/* eslint-disable array-callback-return */
import { Component } from 'react';
import { AdminLogout, GetUserProfile } from '../../api/auth';
import {
    getNotificationList,
    getReadBellIconNotificationList,
    getReadNotificationList,
    getMarkAllNotificationAsRead,
} from '../../api/notifications';
import {
    getcartitems,
    getbuyercartforadminforone,
    getcartlistorderbycustomer,
    placeOrderHistoryById,
} from '../../api/order';
import { getbuyercartofspecificorder, specificOrderHistoryById } from '../../api/specificOrder';
import * as Order from '../../store/allStates/order/actions';
const { history, socket } = require('../../../configs/lib');
const { type } = require('../../../configs/constant');

const pathMapping: any = {
    END_OFFER: `${process.env.PUBLIC_URL}/settings/discount`,
    START_OFFER: `${process.env.PUBLIC_URL}/settings/discount`,
    DISCOUNT_OFFER: `${process.env.PUBLIC_URL}/settings/discount`,
    CHEQUE_RESOLVED: `${process.env.PUBLIC_URL}/cheque/cheque-list`,
    CHEQUE_BOUNCED: `${process.env.PUBLIC_URL}/cheque/cheque-list`,
    CHEQUE_SUBMIT: `${process.env.PUBLIC_URL}/cheque/cheque-list`,
    TARGET_COMPLETION: `${process.env.PUBLIC_URL}/salesman/dashboard`,
    TARGET_SET: `${process.env.PUBLIC_URL}/salesman/dashboard`,
    ORDER_DELIVERED: `${process.env.PUBLIC_URL}/order/buyer-order-history` /*  */,
    PROFILE_ACTIVATION: `${process.env.PUBLIC_URL}/settings/users`,
    USER_REGISTER: `${process.env.PUBLIC_URL}/settings/users`,
    ORDER_PLACED: `${process.env.PUBLIC_URL}/order/buyer-order-history`,
};
export class AbstractProfileLogout extends Component<any, any> {
    mounted = true;
    constructor(props: any) {
        super(props);
        this.state = {
            userDetails: null,
            isLoadingDisplay: false,
            responseMessage: '',
            responseStatus: null,
            cartModal: false,
            notificationList: [],
            notification: [],
            cartCount: 0,
            filter: {
                pageNo: 1,
                limit: 20,
            },
            CustomerId: '',
            created_at: '',
            is_bell_icon_read: false,
            isDropdownOpen: false,
            userDocumentValue: null,
        };
    }

    cartModal = () => {
        this.setState(
            (prevState: any) => ({
                cartModal: !prevState.cartModal,
            }),
            () => {
                if (this.state.cartModal === true) {
                    document.body.classList.add('overflow-hidden');
                } else {
                    document.body.classList.remove('overflow-hidden');
                }
            },
        );
    };

    cartModalClose = () => {
        this.cartModal();
        let UserType = localStorage.getItem('user_type');
        let CustomerId = localStorage.getItem('CustomerId');
        let IsOrderHistory = localStorage.getItem('IsOrderHistory');
        if (
            UserType === type.admin.toString() ||
            UserType === type.officeAdmin.toString() ||
            UserType === type.salesman.toString() ||
            UserType === type.driver.toString()
        ) {
            let url = this.props.location.pathname.split('/')[3];
            if (
                url !== 'buyer-cart-list' &&
                url !== 'cart-list' &&
                url !== 'specific-order' &&
                url !== 'specific-order-history'
            ) {
                if (CustomerId && IsOrderHistory === 'true') {
                    let PlacedOrderId = localStorage.getItem('PlacedOrderId');
                    this.GetPlaceOrderHitory(PlacedOrderId);
                } else if (CustomerId) {
                    this.setState({ CustomerId });
                    this.GetOrderDetailsByCustomerForAdmin(CustomerId);
                } else {
                    this.props.dispatch(Order.cart([]));
                }
            } else if (url === 'specific-order') {
                if (CustomerId && IsOrderHistory === 'true') {
                    let PlacedOrderId = localStorage.getItem('PlacedOrderId');
                    this.GetSpecificOrderHitory(PlacedOrderId);
                } else if (CustomerId) {
                    this.setState({ CustomerId });
                    this.GetSpecificOrderDetails(CustomerId);
                } else {
                    this.props.dispatch(Order.cart([]));
                }
            }
        } else {
            this.GetOrderDetailsByCustomer();
        }
        //window.location.reload();
    };

    GetSpecificOrderDetails = (id: any) => {
        let filter = {
            user_id: id,
        };
        document.body.classList.add('overlay');
        this.setState({ isValueLoadingDisplay: true });
        this.props
            .dispatch(getbuyercartofspecificorder(filter))
            .then((res: any) => {
                document.body.classList.remove('overlay');
                this.setState({
                    isValueLoadingDisplay: false,
                });
            })
            .catch((error: any) => {
                document.body.classList.remove('overlay');
                this.setState({
                    isValueLoadingDisplay: false,
                });
            });
    };

    GetSpecificOrderHitory = (id: any) => {
        this.props
            .dispatch(specificOrderHistoryById(id))
            .then(async (res: any) => {
                let itemList = res.data.orders_product;
                itemList.map((data: any) => {
                    data.slug = data.items.slug;
                    data.module_name = data.order_details.product_name;
                    data.product_per_carton = data.order_details.product_per_carton;
                    data.no_of_carton = data.order_details.no_of_carton;
                    data.total_quantity = data.order_details.total_quantity;
                    data.carton_price = data.order_details.carton_price;
                    data.orignal_price = data.order_details.orignal_price;
                    data.order_price = data.order_details.order_price;
                    data.is_gst = data.order_details.is_gst;
                    data.discount = data.order_details.discount;
                    data.total_price = data.order_details.total_price;
                    data.cartId = id;
                    data.init_qty = data.order_details.init_qty;
                    data.avail_qty = data.order_details.avail_qty;
                });
                this.props.dispatch(Order.cart(itemList));
            })
            .catch((error: any) => {
                this.props.dispatch(Order.cart([]));
            });
    };

    GetOrderDetailsByCustomerForAdmin = (id: any) => {
        let filter = {
            user_id: id,
        };
        document.body.classList.add('overlay');
        this.setState({ isValueLoadingDisplay: true });
        this.props
            .dispatch(getbuyercartforadminforone(filter))
            .then((res: any) => {
                document.body.classList.remove('overlay');
                this.setState({
                    isValueLoadingDisplay: false,
                });
            })
            .catch((error: any) => {
                document.body.classList.remove('overlay');
                this.setState({
                    isValueLoadingDisplay: false,
                });
            });
    };

    GetOrderDetailsByCustomer = () => {
        document.body.classList.add('overlay');
        this.setState({ isValueLoadingDisplay: true });
        this.props
            .dispatch(getcartlistorderbycustomer())
            .then((res: any) => {
                document.body.classList.remove('overlay');
                this.setState({
                    isValueLoadingDisplay: false,
                });
            })
            .catch((error: any) => {
                document.body.classList.remove('overlay');
                this.setState({
                    isValueLoadingDisplay: false,
                });
            });
    };

    GetNotificationListData = (filter: any) => {
        this.props
            .dispatch(getNotificationList(filter))
            .then((res: any) => {
                this.setState({
                    totalPage: res.data.totalPage,
                    totalcount: res.data.count,
                    pageLimit: res.data.limit,
                    notification: res.data.rows,
                    isLoadingDisplay: false,
                });
            })
            .catch((error: any) => {
                this.setState({
                    totalPage: 0,
                    totalcount: 0,
                    pageLimit: 20,
                    notification: [],
                    isLoadingDisplay: false,
                });
            });
    };

    GetReadNotificationById = (id: any, key: string) => {
        this.props
            .dispatch(getReadNotificationList(id))
            .then((res: any) => {
                this.setState(
                    {
                        isLoadingDisplay: false,
                    },
                    () => {
                        this.setState({ isDropdownOpen: false });
                        const { filter } = this.state;
                        this.GetNotificationListData(filter);
                        this.props.history.push(pathMapping[key]);
                    },
                );
            })
            .catch((error: any) => {
                this.setState({
                    isLoadingDisplay: false,
                });
            });
    };

    GetReadNotificationListOnBellIcon = () => {
        this.props
            .dispatch(getReadBellIconNotificationList())
            .then((res: any) => {
                this.setState({
                    isLoadingDisplay: false,
                });
                const { filter } = this.state;
                this.GetNotificationListData(filter);
            })
            .catch((error: any) => {
                this.setState({
                    is_bell_icon_read: false,
                    isLoadingDisplay: false,
                });
            });
        this.setState({ isLoadingDisplay: true });
    };

    GetMarkAllNotificationAsRead = () => {
        this.props
            .dispatch(getMarkAllNotificationAsRead())
            .then((res: any) => {
                this.setState(
                    {
                        isLoadingDisplay: false,
                    },
                    () => {
                        const { filter } = this.state;
                        this.GetNotificationListData(filter);
                    },
                );
            })
            .catch((error: any) => {
                this.setState({
                    is_bell_icon_read: false,
                    isLoadingDisplay: false,
                });
            });
        this.setState({ isLoadingDisplay: true });
    };

    componentDidMount() {
        this.setState({ isLoadingDisplay: true }, () => {
            //this.getNotification();
            this.props
                .dispatch(GetUserProfile())
                .then((res: any) => {
                    this.setState(
                        { isLoadingDisplay: false, userDetails: res.user, userDocumentValue: res.userDocument },
                        () => {
                            if (this.state.userDetails && this.state.userDetails.type === 2) {
                                localStorage.setItem('CustomerId', this.state.userDetails.id);
                                let credentials = {
                                    userid: this.state.userDetails.id,
                                    addedby: this.state.userDetails.id,
                                };
                                socket.emit('joincart', credentials);
                                socket.on('connect', () => {
                                    socket.emit('joincart', credentials);
                                });
                            }
                        },
                    );
                })
                .catch((error: any) => {
                    this.setState({
                        isLoadingDisplay: false,
                    });
                });
        });
        //const { filter } = this.state;
        let UserType = localStorage.getItem('user_type');
        if (UserType === type.buyer.toString()) {
            this.GetCartItemList();
        } else {
            if (this.props.cart.cartItems.length > 0) {
                this.setState({ cartCount: this.props.cart.cartItems.length });
            } else {
                this.setState({ cartCount: 0 });
            }
        }
        const { filter } = this.state;
        this.setState({ isLoadingDisplay: true }, () => {
            this.GetNotificationListData(filter);
        });

        //this.cartsocketcall();
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        let CustomerId = localStorage.getItem('CustomerId');
        if (CustomerId !== prevState.CustomerId) {
            this.props.dispatch(Order.cart([]));
        }
    }

    GetPlaceOrderHitory = (id: any) => {
        this.props
            .dispatch(placeOrderHistoryById(id))
            .then(async (res: any) => {
                let itemList = res.data.orders_product;
                itemList.map((data: any) => {
                    data.slug = data.items.slug;
                    data.module_name = data.order_details.product_name;
                    data.product_per_carton = data.order_details.product_per_carton;
                    data.no_of_carton = data.order_details.no_of_carton;
                    data.total_quantity = data.order_details.total_quantity;
                    data.orignal_price = data.order_details.orignal_price;
                    data.order_price = data.order_details.order_price;
                    data.is_gst = data.order_details.is_gst;
                    data.discount = data.order_details.discount;
                    data.total_price = data.order_details.total_price;
                    data.cartId = id;
                });
                this.props.dispatch(Order.cart(itemList));
            })
            .catch((error: any) => {
                this.props.dispatch(Order.cart([]));
            });
    };

    GetCartItemList = (newfilter?: any) => {
        this.props
            .dispatch(getcartitems(newfilter))
            .then(async (res: any) => {
                let UserType = localStorage.getItem('user_type');
                if (UserType === type.buyer.toString() && res.data.rows.length) {
                    localStorage.setItem('orderid', res.data.rows[0].order_id);
                }
                this.setState({ cartCount: res.data.count });
            })
            .catch((error: any) => {
                this.setState({ cartCount: 0 });
            });
    };

    componentWillUnmount() {
        this.cartsocketdisconnect();
    }

    // getNotification = () => {
    //   this.props
    //     .dispatch(getNotificationList())
    //     .then((res: any) => {
    //       this.setState({ notificationList: res.data.rows });
    //     })
    //     .catch((error: any) => {
    //       this.setState({
    //         notificationList: [],
    //       });
    //     });
    // };

    handleLogOut = () => {
        this.props
            .dispatch(AdminLogout())
            .then((res: any) => {
                localStorage.clear();
                this.cartsocketdisconnect();
                history.push(`${process.env.PUBLIC_URL}/signin`);
            })
            .catch((error: any) => {});
    };

    cartsocketcall() {
        socket.on('getCartCount', (data: any) => {
            //this.setState({ cartCount: data.count })
        });
    }

    cartsocketdisconnect = () => {
        let credentials = {
            userid: this.state.userDetails && this.state.userDetails.id,
            addedby: this.state.userDetails && this.state.userDetails.id,
        };
        socket.emit('leavecart', credentials);
        socket.off('getCartCount');
        socket.disconnect();
    };
}
export default AbstractProfileLogout;
